import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Inject, Injectable, Optional } from '@angular/core';
import { Response } from 'express-serve-static-core';

@Injectable()
export class ServerResponseService {
  constructor(
    @Optional()
    @Inject(RESPONSE)
    private response: Response
  ) {}

  setStatus(code: number, message?: string): this {
    if (this.response) {
      this.response.status(code).send(message);
    }

    return this;
  }

  setStatusOnly(code: number): this {
    if (this.response) {
      this.response.status(code);
    }

    return this;
  }

  redirect(code: 301 | 302, location: string): this {
    if (this.response) {
      // this.response.redirect(code, location);
      this.response.status(code);
      this.response.setHeader('Location', location);
    }

    return this;
  }
}
